import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, pickAll, propOr } from 'ramda';

import { actions } from 'store/newDocumentStore';
import DocumentLoader from 'routes/Documents/containers/DocumentLoaderContainer';
import DocumentProvider from 'routes/Documents/containers/DocumentProvider';
import ViewStateContainer from 'routes/Documents/containers/ViewStateContainer';

import Scores from '../components/Scores';

const ScoresContainer = ({ edit, create, tokens }) => (
  <DocumentLoader names={['sdmt', 'msis', 'fss', 'msnq', 'fsmc', 'status']}>
    <DocumentProvider>
      <ViewStateContainer>
        <Scores onStartEdit={edit} onCreate={create} tokens={tokens} />
      </ViewStateContainer>
    </DocumentProvider>
  </DocumentLoader>
);

ScoresContainer.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
  tokens: PropTypes.array,
};

const mapStateToProps = compose(pickAll(['tokens']), propOr({}, 'studyTokens'));

export default connect(mapStateToProps, { edit: actions.createCommit, create: actions.createDocumentAndCommit })(
  ScoresContainer,
);
